import React from "react";
import BaseModal from "../../components/ui/BaseModal";
import CloseIcon from "@mui/icons-material/Close";

const TechnicianTermsConditions = ({ open, close }) => {
  return (
    <BaseModal
      className="-top-[200px] overflow-auto"
      open={open}
      close={close}
    >
      <div className="py-7 px-8 xl:w-[1000px] lg:w-[900px] sm:w-[700px] relative font-poppins">
        <div className="flex items-center justify-between border-b pb-1">
          <h6 className="text-dark font-normal">Terms and Conditions</h6>
          <button
            onClick={() => close(false)}
            className="text-gray-500 hover:text-gray-800"
          >
            <CloseIcon className="text-2xl" onClick={() => close(false)} />
          </button>
        </div>
        <div className="mt-6 max-h-[65vh] overflow-y-auto pr-2 text-base leading-relaxed text-gray-700 space-y-4">
          <p className="font-normal text-sm">
            <span className="font-semibold ">Effective Date :</span> 01/06/2020
          </p>
          <p className="font-normal text-sm">
            <span className="font-semibold ">Last Updated :</span> 01/07/2025
          </p>

          <p className="font-normal text-sm">
            Welcome to <span className="font-semibold">Tech Domain</span>. By
            accessing or using our website, services, platform, or network of
            technicians, you agree to be bound by the following Terms and
            Conditions. Please read them carefully before proceeding.
          </p>
          <p className="border-b pb-4 font-normal text-sm">
            These Terms apply to all users, clients, partners, contractors, and
            technicians who engage with Tech Domain in any capacity.
          </p>

          <h6 className="font-medium text-dark mb-3">Introduction</h6>
          <p className="font-normal text-sm">
            Tech Domain (“we”, “us”, “our”) provides global field service
            solutions, connecting businesses with vetted, certified technicians.
            Our platform enables project posting, technician matching, job
            management, and support for IT, networking, AV, and related
            infrastructure services.
          </p>
          <p className="border-b pb-4 font-normal text-sm">
            By using our services, you agree to these Terms and our Privacy
            Policy. If you do not agree, please do not use our services.
          </p>

          <h6 className="font-medium text-dark mb-3">Definitions</h6>
          <ul className="list-disc pl-6 space-y-1 font-normal text-sm">
            <li>
              <span className="font-semibold">Client:</span> Any individual or
              organization using the platform to post work orders or hire
              technicians.
            </li>
            <li>
              <span className="font-semibold">Technician/Contractor:</span> Any
              individual or business registered on our platform to deliver field
              services.
            </li>
            <li>
              <span className="font-semibold">User:</span> Any person accessing
              or using Tech Domain's website or platform.
            </li>
            <li>
              <span className="font-semibold">Platform:</span> The digital
              systems, tools, and software services owned and operated by Tech
              Domain.
            </li>
          </ul>

          <h6 className="font-medium text-dark mb-3"> Use of Services</h6>
          <p className="font-normal text-sm">
            You agree to use Tech Domain's services only for lawful purposes and
            in accordance with these Terms. <br />
            You must not:
          </p>
          <ul className="list-disc pl-6 space-y-1 font-normal text-sm">
            <li>Violate any applicable laws or regulations</li>
            <li>Use the platform for fraudulent or unauthorized purposes</li>
            <li>Interfere with the platform’s performance or security</li>
            <li>Post misleading, false, or harmful information</li>
          </ul>
          <p className="border-b pb-4 font-normal text-sm">
            We reserve the right to suspend or terminate access to our platform
            at our discretion if misuse is detected.
          </p>

          <h6 className="font-medium text-dark mb-3">
            Technician Responsibilities
          </h6>
          <p className="font-normal text-sm">
            All technicians and service providers registered with Tech Domain
            must:
          </p>
          <ul className="list-disc pl-6 space-y-1 font-normal text-sm">
            <li>Maintain valid licenses, insurances, and certifications</li>
            <li>Deliver services in a professional, safe, and timely manner</li>
            <li>Use appropriate tools and safety equipment</li>
            <li>Represent Tech Domain with integrity at all times</li>
            <li>
              Accurately report work completion and submit required
              documentation
            </li>
          </ul>
          <p className="border-b pb-4 font-normal text-sm text-[#FF3A3A]">
            Non-compliance may result in suspension or removal from the Tech
            Domain Platform.
          </p>

          <h6 className="font-medium text-dark mb-3">
            Client Responsibilities
          </h6>
          <p className="font-normal text-sm">Client must:</p>
          <ul className="list-disc pl-6 space-y-1 font-normal text-sm">
            <li>Provide accurate and complete work order details</li>
            <li>Ensure safe access to job sites</li>
            <li>Communicate expectations clearly and respectfully</li>
            <li>Pay invoices according to agreed payment terms</li>
          </ul>
          <p className="border-b pb-4 font-normal text-sm">
            Tech Domain is not responsible for project delays caused by
            incomplete or inaccurate client input.
          </p>

          <h6 className="font-medium text-dark mb-3"> Payment Terms</h6>
          <ul className="list-disc pl-6 space-y-1 font-normal text-sm">
            <li>
              All work orders are subject to the pricing, payment schedule, and
              currency outlined during job creation or service agreement.
            </li>
            <li>
              Clients agree to pay all approved charges in accordance with the
              invoice terms (e.g., Net 15/30).
            </li>
            <li>
              Tech Domain may process technician payments after client approval
              or following automated approval timelines.
            </li>
          </ul>
          <p className="border-b pb-4 font-normal text-sm">
            Late payments may result in suspension of services and/or late fees.
          </p>

          <h6 className="font-medium text-dark mb-3">
            Cancellations and Rescheduling
          </h6>
          <p className="font-normal text-sm">
            Work orders may be rescheduled or cancelled under the following
            terms:
          </p>
          <ul className="list-disc pl-6 space-y-1 font-normal text-sm">
            <li>Clients must provide reasonable notice for cancellations</li>
            <li>
              Technicians must notify Tech Domain promptly if unable to attend a
              scheduled job
            </li>
            <li>Cancellation fees may apply for late notice or no-shows</li>
          </ul>
          <p className="border-b pb-4 font-normal text-sm">
            Tech Domain reserves the right to enforce cancellation policies at
            its discretion.
          </p>

          <h6 className="font-medium text-dark mb-3">
            Liability and Disclaimers
          </h6>
          <p className="font-normal text-sm">
            Tech Domain provides a platform to connect clients with technicians
            but does not guarantee the outcome of any project. While we screen
            technicians for qualifications and professionalism:
          </p>
          <ul className="list-disc pl-6 space-y-1 font-normal text-sm">
            <li>
              We are not liable for damages, losses, or delays caused by
              third-party service providers.
            </li>
            <li>
              We do not accept responsibility for client-provided equipment or
              environments.
            </li>
            <li>Users engage with our platform at their own risk.</li>
          </ul>

          <h6 className="font-medium text-dark mb-3">Intellectual Property</h6>
          <p className="border-b pb-4 font-normal text-sm">
            All content on the Tech Domain website and platform, including
            logos, text, software, and graphics, is the property of Tech Domain
            or its licensors and is protected by intellectual property laws.{" "}
            <br />
            You may not copy, reproduce, modify, or distribute any part of our
            content without written permission.
          </p>

          <h6 className="font-medium text-dark mb-3">
            Confidentiality and Data Protection
          </h6>
          <ul className="list-disc pl-6 space-y-1 font-normal text-sm">
            <li>
              Users must not share confidential project, client, or technician
              information with unauthorised parties.
            </li>
            <li>
              We collect and process personal data in accordance with our
              [Privacy Policy].
            </li>
            <li>
              {" "}
              Users are responsible for keeping their login credentials secure.
            </li>
          </ul>

          <h6 className="font-medium text-dark mb-3"> Governing Law</h6>
          <p className="border-b pb-4 font-normal text-sm">
            These Terms are governed by the laws of [Insert Governing Country].
            Disputes resolved in the courts of [Insert Jurisdiction].
          </p>

          <h6 className="font-medium text-dark mb-3">Changes to these Terms</h6>
          <p className="border-b pb-4 font-normal text-sm">
            We may revise these Terms at any time by updating this page.
            Continued use of the platform constitutes acceptance of the revised
            Terms. Users are encouraged to review this page regularly.
          </p>

          <h6 className="font-medium text-dark mb-3"> Contact Us</h6>
          <div className="space-y-2 text-sm leading-relaxed text-gray-700">
            <p className="font-normal text-sm">
              If you have any questions or concerns regarding these Terms and
              Conditions, please contact us:
            </p>
            <p className="font-normal text-sm ">
              Email :{" "}
              <a
                href="mailto:Info@techdomain.com.au"
                className="text-primary font-normal text-sm"
              >
                Info@techdomain.com.au
              </a>
            </p>
            <p className="font-normal text-sm">
              Phone : <span className="font-semibold">+61 (02) 9158 3294</span>
            </p>
            <p className="font-normal text-sm">
              Address :{" "}
              <span className="font-semibold">
                14 St Mirren Avenue, North Kellyville, NSW, 2155, Australia
              </span>
            </p>
            <p className="text-[#FF3A3A] mt-2 font-normal text-sm">
              By using Tech Domain’s services, you confirm that you have read,
              understood, and agree to abide by these Terms &amp; Conditions.
            </p>
          </div>
        </div>
      </div>
    </BaseModal>
  );
};

export default TechnicianTermsConditions;
